import { create } from "zustand";

import type { FlowWindow } from "../api/types";

/**
 * Выбранное окно статистики коротких рынков — общее на всю вкладку.
 *
 * Стор, а не useState в панели, ровно по одной причине: панель живёт на странице
 * рынка, а рынки короткие, и оператор переходит с окна на окно десятки раз за
 * сессию. Локальное состояние сбрасывалось бы на умолчание при каждом переходе, то
 * есть «поставил 30 суток» держалось бы до следующего рынка.
 *
 * Без записи в localStorage, и это осознанно: умолчание задаёт СЕРВЕР (ответ несёт
 * flow_window), а сохранённая копия стала бы вторым местом, где живёт то же
 * значение, — с обычной ценой расхождения двух копий одной константы. Перезагрузка
 * вкладки возвращает серверное умолчание, и это правильный ответ на вопрос «что я
 * сейчас вижу».
 *
 * `undefined` означает «оператор не выбирал»: тогда запрос уходит без параметра, и
 * окно назначает сервер.
 */
interface FlowWindowStore {
  /** Что выбрано в переключателе. Пусто — умолчание сервера. */
  picked: FlowWindow | undefined;
  pick: (window: FlowWindow) => void;
}

export const useFlowWindow = create<FlowWindowStore>((set) => ({
  picked: undefined,
  pick: (window) => set({ picked: window }),
}));
